/**
 * Main JS file for Casper behaviours
 */

/*globals jQuery, document */
(function ($) {
    "use strict";

    /* alternate hover color in .post-content */
    function hoverColor(element, color) {
      return function() {
        element.stop().animate({"color": color}, 150);
      }
    }
	
	function colorSwap (index) {
        switch(index%4) {
          case 0:
            $(this).hover(hoverColor($(this),"#e30049"),
              hoverColor($(this),"#fff")
            );
            break;
          case 1:
            $(this).hover(hoverColor($(this),"#2956f7"),
              hoverColor($(this),"#fff")
            );
            break;
          case 2:
            $(this).hover(hoverColor($(this),"#32bd7c"),
              hoverColor($(this),"#fff")
            );
            break;
          case 3:
            $(this).hover(hoverColor($(this),"#fd5d0f"),
              hoverColor($(this),"#fff")
            );
            break;
        }
	}

    $(document).ready(function() {
	  $(".gh-content a").each(colorSwap);
	  $(".gh-head-menu a").each(colorSwap);
	  $(".post-card-content-link").each(colorSwap);
	  $(".post-card-byline-content a").each(colorSwap);
	  $(".article-byline-content a").each(colorSwap);
    });

}(jQuery));
